import { TFunction } from '@wix/yoshi-flow-editor';

import { WidgetApi } from './model';

let counter = 0;

export const getDummyVisitorMessages = (t: TFunction): WidgetApi.Message[] => [
  {
    id: '1',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.SITE_VISITOR,
    body: {
      mainText: t('app.demoContent.question1Text'),
    },
  },
];

export const getDummyAssistantMessages = (
  t: TFunction,
): WidgetApi.Message[] => [
  {
    id: '4',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.demoContent.answer2Text'),
      additionalData: [
        {
          id: 'cta',
          type: 'site_pages',
          title: t('app.demoContent.answer2Cta'),
          url: '/contact-us',
        },
      ],
    },
  },
  {
    id: '5',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.demoContent.answer3Text'),
      additionalData: [
        {
          id: 'cta-products',
          type: 'site_pages',
          title: t('app.demoContent.answer3Cta1'),
          url: '/products',
        },
        {
          id: 'cta-services',
          type: 'site_pages',
          title: t('app.demoContent.answer3Cta2'),
          url: '/services',
        },
        {
          id: 'cta-blog',
          type: 'site_pages',
          title: t('app.demoContent.answer3Cta3'),
          url: '/blog',
        },
        {
          id: 'cta-about-us',
          type: 'site_pages',
          title: t('app.demoContent.answer3Cta4'),
          url: '/about-us',
        },
      ],
    },
  },
];

export const getDummyBubbleMessages = (t: TFunction): WidgetApi.Message[] => [
  {
    id: '4',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.settings.design.bubble.dummyText'),
    },
  },
];

export const getDummyContactForm = (t: TFunction): WidgetApi.Message[] => [
  {
    id: '4',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    triggerId: '1',
    conversationId: '1',
    messageType: WidgetApi.MessageType.CONTACT_FORM,
    body: {
      mainText: t('app.settings.design.customize.formDummyMessage'),
    },
  },
];

export const getDummyCardMessages = (t: TFunction): WidgetApi.Message[] => [
  {
    id: '2',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.demoContent.answer1Text'),
      additionalData: [
        {
          id: 'p1',
          type: 'products',
          title: t('app.demoContent.answer1Product1Title'),
          img: 'editor-dummy-product-1',
          url: '/product/1',
          price: '$129.90',
        },
        {
          id: 'p2',
          type: 'products',
          title: t('app.demoContent.answer1Product1Title'),
          img: 'editor-dummy-product-2',
          url: '/product/2',
          price: '$89.90',
        },
      ],
    },
  },
];

export const getDummyMessages = (t: TFunction): WidgetApi.Message[] => [
  {
    id: '1',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.SITE_VISITOR,
    body: {
      mainText: t('app.demoContent.question1Text'),
    },
  },
  {
    id: '2',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.demoContent.answer1Text'),
      additionalData: [
        {
          id: 'p1',
          type: 'products',
          title: t('app.demoContent.answer1Product1Title'),
          img: 'editor-dummy-product-1',
          url: '/product/1',
          price: '$129.90',
        },
        {
          id: 'p2',
          type: 'products',
          title: t('app.demoContent.answer1Product1Title'),
          img: 'editor-dummy-product-2',
          url: '/product/2',
          price: '$89.90',
        },
      ],
    },
  },
  {
    id: '3',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.SITE_VISITOR,
    body: {
      mainText: t('app.demoContent.question2Text'),
    },
  },
  {
    id: '4',
    createdDate: new Date(Date.now() + counter++),
    sender: WidgetApi.Sender.ASSISTANT,
    body: {
      mainText: t('app.demoContent.answer2Text'),
      additionalData: [
        {
          id: 'cta',
          type: 'site_pages',
          title: t('app.demoContent.answer2Cta'),
          url: '/contact-us',
        },
      ],
    },
  },
];
